import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ICompany } from '../features/companies/models/CompanyModel';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CompanyService {
   constructor(private http: HttpClient) {}

  getCompanies() {
    return this.http.get<ICompany[]>(`${environment.API_URL}/api/companies`);
  }

  getCompanyById(id: string) {
    return this.http.get(`${environment.API_URL}/api/companies/${id}`);
  }

  createCompany(company: any) {
    return this.http.post(`${environment.API_URL}/api/companies`, company);
  }

  vinculateCompanyToVessel(companyId: string, vesselId: string) {
    return this.http.post(`${environment.API_URL}/api/companies/vinculate`, { companyId, vesselId });
  }

  desvinculateCompanyFromVessel(companyId: string, vesselId: string) {
    return this.http.post(`${environment.API_URL}/api/companies/desvinculate`, { companyId, vesselId });
  }

  updateCompany(id: string, company: any) {
    return this.http.put(`${environment.API_URL}/api/companies/${id}`, company);
  }

  assignManuals(companyId: string, manualIds: string[]) {
    return this.http.post(`${environment.API_URL}/api/companies/${companyId}/manuals`, { manualIds });
  }

  getAssignedManuals(companyId: string) {
    return this.http.get<string[]>(`${environment.API_URL}/api/companies/${companyId}/manuals`);
  }

  deleteCompany(id: string) {
    return this.http.delete(`${environment.API_URL}/api/companies/${id}`);
  }
}
